import hideZeroFloat from "./hide.zero.float";
import numberSpaces from "./numbers.with.spaces";

const prettyFloat = float => numberSpaces( hideZeroFloat( +parseFloat( float ).toFixed( 3 ) ) );

export default prettyFloat;